var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8.23393 2.63434c.31241-.31242.81895-.31242 1.13137 0l4.8 4.8c.3124.31242.3124.81895 0 1.13137l-4.8 4.79999c-.31242.3124-.81896.3124-1.13137 0-.31242-.3124-.31242-.8189 0-1.1314l3.43427-3.43428-9.26859.00001c-.44183-.00001-.8-.35818-.8-.80001 0-.44182.35817-.8.8-.8h9.26859l-3.43427-3.43431c-.31242-.31242-.31242-.81895 0-1.13137z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6ed9ec9f2786e90ac10b5e2ec0fad85a.svg";
export { ForwardRef as ReactComponent };